enum AuthType {
  Facebook = 'Facebook',
  Apple = 'Apple',
  Google = 'Google',
  Email = 'Email',
}
export default AuthType;
